import { HttpErrorResponse } from '@angular/common/http';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Injectable, HostListener } from '@angular/core';
import { environment } from '../../environments/environment';
import { LocalStorageKeys, Usuario } from 'src/app/shared/model';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})

export class SharedFunctions {
    constructor(
        private router: Router,
        private datePipe: DatePipe,
        protected _http: HttpClient
    ) {
    }

    public showMessage(mensaje: string, titulo: string) {
        DialogUtility.confirm({
            title: titulo,
            content: mensaje,
            okButton: { text: 'Aceptar' },
            cancelButton: { text: '' },
            showCloseIcon: true,
            position: { X: 'center', Y: 'center' },
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' }
        });
    }

    public showConfirm(mensaje: string, titulo: string) {
        DialogUtility.confirm({
            title: titulo,
            content: mensaje,
            okButton: { text: 'Aceptar' },
            cancelButton: { text: 'Cancelar' },
            showCloseIcon: true,
            position: { X: 'center', Y: 'center' },
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' }
        });
    }

    public handleError(err: HttpErrorResponse, showErrorMessage: boolean = false) {

        var errorMessage = "";
        
        if (err != null)
        {
            switch (err.status)
            {
                //Server caido
                case 0:
                    errorMessage = "Ocurrió un error comunicándose con el servidor";
                    break;

                //Usuario no logueado / Sesion expirada / Token vencido
                case 401:
                    errorMessage = "Su sesión expiró. Por favor iniciela nuevamente";

                    this.clearLocalStorage();
                    this.router.navigate(['auth/login']);
                    break;
            
                default:
                    errorMessage = err?.error?.Message ?? "Ocurrió un error solicitando los datos al servidor";
                    break;
            }
        }
        else
            errorMessage = err?.error?.Message ?? "Ocurrió un error solicitando los datos al servidor.";

        if (showErrorMessage)
            this.showMessage(errorMessage, "Error");

        return errorMessage;
    }

    public clearLocalStorage() {
        localStorage.clear();
    }

    public setLocalStorageValue(key: string, value: any) {
        try {
            return localStorage.setItem(key, value);
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public getLocalStorageValue(key: string): any {
        try {
            return localStorage.getItem(key);
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public getLoggedUser(): Usuario {
        try {
            return JSON.parse(this.getLocalStorageValue(LocalStorageKeys.Usuario));
        }
        catch(e) {
            console.error(e);
        }

        return null;
    }

    public getLoggedUserMenus() {
        try {
            return JSON.parse(this.getLocalStorageValue(LocalStorageKeys.Menu));
        }
        catch(e) {
            console.error(e);
        }
        
        return null;
    }

    public getRichTextToolbarItems(): object {
        return {
            items: ['Undo', 'Redo', '|',
                'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
                'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
                'SubScript', 'SuperScript', '|',
                'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
                'Indent', 'Outdent', '|', 'CreateLink',
                'Image', '|', 'ClearFormat', 'Print', 'SourceCode' /*, '|', 'FullScreen'*/
            ]
        };
    }

    public getRichTextImageSettings(resource: string, saveUrl: string, removeUrl: string = null): object {
        var loggedUser = this.getLoggedUser();
        if (loggedUser == null || loggedUser.Login == null)
            return null;

        var uploadPath = environment.uploadTempUrl;
        if (!uploadPath.startsWith("http"))
            uploadPath = window.location.origin + uploadPath;

        return {
            // saveFormat: 'Base64',
            path: uploadPath + resource + "/" + loggedUser.Login + "/", //'https://localhost:44376/Temp/MensajeUsuario/admin/',
            saveUrl: saveUrl //'https://localhost:44376/api/mensajeUsuario/attach/temp'
            // removeUrl: removeUrl //'https://ej2.syncfusion.com/services/api/uploadbox/Remove'
        };
    }

    public convertToQueryString<T>(value: T) {
        var queryString = "";
        if (value != null)
            Object.keys(value)?.forEach(e => {

                if (value[e] != null && value[e].toString().length > 0) {
                    queryString += (queryString.length == 0 ? "?" : "&") + e + "=";

                    if ((typeof value[e]).toString() == "object") {
                        //Para verificar si se trata de una fecha
                        if (value[e].toString().includes("GMT"))
                            queryString += this.datePipe.transform(value[e],"yyyy-MM-dd");
                        else
                            queryString += value[e];
                    }
                    else
                        queryString += value[e];
                }
            });

        return queryString;
    }

    public reloadCurrentRoute() {
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate([currentUrl]);
        });
    }

    public getMonthList() {
        return [
            { Id: 1, Nombre: "Enero" },
            { Id: 2, Nombre: "Febrero" },
            { Id: 3, Nombre: "Marzo" },
            { Id: 4, Nombre: "Abril" },
            { Id: 5, Nombre: "Mayo" },
            { Id: 6, Nombre: "Junio" },
            { Id: 7, Nombre: "Julio" },
            { Id: 8, Nombre: "Agosto" },
            { Id: 9, Nombre: "Septiembre" },
            { Id: 10, Nombre: "Octubre" },
            { Id: 11, Nombre: "Noviembre" },
            { Id: 12, Nombre: "Diciembre" }
        ];
    }

    public checkIfFileExists(url: string): Observable<boolean> {
        if (url != null && url.length > 0)
            return this._http.get(url).pipe(map(() => true), catchError(() => of(false)));
        return of(false);
    }

    // @HostListener('window:resize', ['$event'])
    public sizeView() {
       return (window.screen.width < 500);
    }
}
